module.exports = __webpack_public_path__ + "media/images/mailer_full_team-db21a5b0.png";